import React from 'react';
import { Wgs84Coordinates } from '../../models';
import { Path } from './path';
import L from 'leaflet';

interface LineProps {
  from?: Wgs84Coordinates;
  to?: Wgs84Coordinates;
}

const connvertToNumbers = ({
  lat,
  lon,
}: {
  lat?: number | string;
  lon?: number | string;
}): Wgs84Coordinates => {
  return {
    lat: Number(lat),
    lon: Number(lon),
  };
};

export function Line({ from, to }: LineProps) {
  if (!from || !to) {
    return null;
  }

  const parsed: { from: Wgs84Coordinates; to: Wgs84Coordinates } = {
    from: connvertToNumbers(from),
    to: connvertToNumbers(to),
  };

  const pointsForPath: Wgs84Coordinates[] = [parsed.from, parsed.to];

  const pathOptions: L.PolylineOptions = {
    color: '#f00',
    weight: 3,
    dashArray: '5, 5',
  };

  return <Path points={pointsForPath} options={pathOptions} />;
}
